import { gql } from '@apollo/client'

const DELETE_PATIENT_TAG = gql`
  mutation DELETE_PATIENT_TAG($patientTag: ID!) {
    deletePatientTag(patientTag: $patientTag) {
      id
    }
  }
`

export default DELETE_PATIENT_TAG
